import React from 'react'
import { Link } from 'react-router-dom'

export default function Forbidden() {
  return (
    <div className="py-24 sm:py-32 px-4 sm:px-6 lg:px-8 bg-neutral-50 flex items-center justify-center min-h-[70vh]">
      <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-3xl border border-neutral-200 shadow-sm">
        <div className="w-20 h-20 rounded-full bg-red-50 text-red-600 flex items-center justify-center text-3xl font-extrabold mx-auto">
          403
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-[#0c304d]">
          Adgang nægtet
        </h1>
        <p className="text-neutral-600 text-sm sm:text-base leading-relaxed">
          Du har desværre ikke tilladelse til at tilgå denne ressource.
        </p>
        <div className="pt-2 flex flex-col sm:flex-row justify-center items-stretch sm:items-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#f39223] hover:bg-[#e08112] text-white font-bold text-sm px-6 py-3.5 rounded-full transition-colors shadow-xs"
          >
            <i className="fa-solid fa-house text-xs" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-neutral-100 hover:bg-neutral-200 text-[#0c304d] font-semibold text-sm px-6 py-3.5 rounded-full transition-colors"
          >
            <span>Kontakt os</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
